module.exports = __webpack_public_path__ + "img/helpcenter.ng.a047a11a.svg";